<template>
  <div class="login-page">
    <div class="ambient ambient-left" aria-hidden="true"></div>
    <div class="ambient ambient-right" aria-hidden="true"></div>

    <div class="login-shell">
      <aside class="brand-panel" aria-hidden="true">
        <div class="brand-mark">HM</div>
        <h2>Herrametal</h2>
        <p>Gestion de operaciones y seguridad en un solo punto.</p>
        <ul class="brand-points">
          <li>
            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M12.5 15.5a2.5 2.5 0 1 0-3-3l-3.5 3.6a1 1 0 1 0 1.4 1.4l3.5-3.5.2-.2.3.3 5.5 5.5a1 1 0 1 0 1.4-1.4l-5.5-5.5-.3-.3.2-.2 3.5-3.5a1 1 0 1 0-1.4-1.4l-3.5 3.6a2.5 2.5 0 0 0-3 3l-3.5 3.5a1 1 0 1 0 1.4 1.4l3.5-3.5z"/>
            </svg>
            Sistema de gestión industrial
          </li>
          <li>
            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M12 1a5 5 0 0 0-5 5v3H5v12h14V9h-2V6a5 5 0 0 0-5-5zm0 2a3 3 0 0 1 3 3v3H9V6a3 3 0 0 1 3-3zm-5 8h10v8H7v-8z"/>
            </svg>
            Acceso seguro y controlado
          </li>
          <li>
            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"/>
            </svg>
            Operaciones en tiempo real
          </li>
        </ul>
        <div class="industrial-stripe" aria-hidden="true"></div>
      </aside>

      <div class="login-card">
        <div class="logo-badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" role="img">
            <path
              fill="white"
              d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-6 6.73V17a1 1 0 1 0 2 0v-1.27a2 2 0 1 0-2 0ZM10 9V7a2 2 0 1 1 4 0v2Z"
            />
          </svg>
        </div>
        <h1>Bienvenido de nuevo</h1>
        <p>Ingresa con tu cuenta para continuar en el panel de Herrametal.</p>

        <form class="login-form" @submit.prevent="submit">
          <div class="field">
            <label>Usuario o correo</label>
            <div class="input-wrap">
              <input
                v-model.trim="email"
                type="text"
                placeholder="ejemplo@empresa.com"
                autocomplete="username"
                required
              />
            </div>
          </div>

          <div class="field">
            <div class="field-row">
              <label>Contrasena</label>
              <router-link class="forgot" :to="{ name: 'forgot-password' }">
                ¿Olvidaste tu contrasena?
              </router-link>
            </div>
            <div class="input-wrap">
              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="••••••••"
                autocomplete="current-password"
                required
              />
              <button
                type="button"
                class="toggle"
                @click="showPassword = !showPassword"
                :aria-label="showPassword ? 'Ocultar clave' : 'Mostrar clave'"
              >
                <svg v-if="showPassword" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M12 5c4.5 0 8.27 2.91 9.54 7a10.6 10.6 0 0 1-2.16 3.6l-1.42-1.42A8.6 8.6 0 0 0 19.6 12C18.5 8.86 15.53 6.5 12 6.5a7.5 7.5 0 0 0-2.43.4L8.1 5.43A9.7 9.7 0 0 1 12 5Zm-8.64 2.05L5 8.69a8.7 8.7 0 0 0-1.6 3.31C4.5 15.14 7.47 17.5 11 17.5c1 0 1.96-.2 2.84-.56l1.58 1.58A9.7 9.7 0 0 1 11 19c-4.5 0-8.27-2.91-9.54-7a10.6 10.6 0 0 1 1.9-3.95Zm7.44 3.44 2.7 2.7a2 2 0 0 1-2.7-2.7Zm3.6 3.6-2.7-2.7a2 2 0 0 1 2.7 2.7ZM3.27 2 22 20.73 20.73 22 2 3.27Z"
                  />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M12 5c4.5 0 8.27 2.91 9.54 7-1.27 4.09-5.04 7-9.54 7s-8.27-2.91-9.54-7c1.27-4.09 5.04-7 9.54-7Zm0 2c-3.5 0-6.5 2.23-7.74 5 1.24 2.77 4.24 5 7.74 5s6.5-2.23 7.74-5C18.5 9.23 15.5 7 12 7Zm0 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="login-actions">
            <label class="remember">
              <input v-model="remember" type="checkbox" />
              Recordarme
            </label>
          </div>

          <div v-if="error" class="error-text">{{ error }}</div>

          <button class="login-btn" type="submit" :disabled="loading">
            <span v-if="loading" class="spinner">
              <v-progress-circular indeterminate color="white" size="18" width="2" />
            </span>
            <span v-else>Ingresar al Panel</span>
          </button>
        </form>

        <div class="support">Soporte tecnico: <span>v1.2.0</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      remember: true,
      showPassword: false,
      error: "",
    };
  },
  computed: {
    ...mapGetters("auth", ["loading"]),
  },
  methods: {
    async submit() {
      if (!this.email || !this.password) {
        this.error = "Completa usuario y contrasena.";
        return;
      }

      this.error = "";
      try {
        await this.$store.dispatch("auth/login", {
          email: this.email,
          password: this.password,
          remember: this.remember,
        });
        const redirect = this.$route.query.redirect || "/";
        this.$router.push(redirect);
      } catch (err) {
        this.error = "No pudimos iniciar sesion. Verifica tus datos.";
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  --bg-top: #e2e8f0;
  --bg-bottom: #cbd5e1;
  --accent: #1e3a5f;
  --accent-strong: #3b82f6;
  --ink: #0f172a;
  --muted: #475569;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: radial-gradient(ellipse at 20% 0%, #f8fafc 0%, var(--bg-top) 40%, var(--bg-bottom) 100%);
  padding: 24px;
  font-family: "Poppins", "Segoe UI", system-ui, sans-serif;
}

.ambient {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  pointer-events: none;
}

.ambient-left {
  width: 500px;
  height: 500px;
  top: -180px;
  left: -160px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.22), rgba(59, 130, 246, 0) 70%);
}

.ambient-right {
  width: 600px;
  height: 600px;
  right: -220px;
  bottom: -280px;
  background: radial-gradient(circle, rgba(30, 58, 95, 0.28), rgba(30, 58, 95, 0) 70%);
}

.login-shell {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 920px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(148, 163, 184, 0.2);
}

.brand-panel {
  background: linear-gradient(165deg, #0f172a 0%, #1e3a5f 45%, #2563eb 100%);
  color: #f8fafc;
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  position: relative;
}

.brand-mark {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #f8fafc;
  background: linear-gradient(145deg, rgba(59, 130, 246, 0.25), rgba(34, 59, 106, 0.4));
  border: 2px solid rgba(96, 165, 250, 0.4);
  box-shadow: 0 8px 24px rgba(34, 59, 106, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.brand-panel h2 {
  margin: 6px 0 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  text-transform: uppercase;
}

.brand-panel p {
  margin: 0;
  font-size: 14px;
  color: rgba(148, 163, 184, 0.95);
  line-height: 1.5;
  font-weight: 500;
}

.brand-points {
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.brand-points li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  letter-spacing: 0.02em;
  color: rgba(226, 232, 240, 0.85);
  font-weight: 500;
}

.brand-points li svg {
  flex-shrink: 0;
  color: #60a5fa;
  filter: drop-shadow(0 0 6px rgba(96, 165, 250, 0.5));
}

.industrial-stripe {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #60a5fa 25%, #94a3b8 50%, #60a5fa 75%, #3b82f6 100%);
  opacity: 0.6;
}

.login-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(12px);
  padding: 36px 32px;
  text-align: center;
}

.logo-badge {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: linear-gradient(145deg, var(--accent), var(--accent-strong));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 16px 32px rgba(30, 58, 95, 0.35), 0 0 0 1px rgba(96, 165, 250, 0.3);
}

.login-card h1 {
  margin: 0 0 10px;
  font-size: 26px;
  font-weight: 800;
  color: var(--ink);
  letter-spacing: -0.02em;
}

.login-card p {
  margin: 0 0 18px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.45;
}

.login-form {
  display: grid;
  gap: 12px;
  text-align: left;
}

.field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0 0 5px 4px;
}

.field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 0 4px;
}

.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #d7e0ee;
  border-radius: 11px;
  padding: 9px 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input-wrap:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

.input-wrap input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 13px;
  color: #1a2333;
}

.input-wrap input::placeholder {
  color: #94a3b8;
}

.toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 0 2px;
  transition: color 0.2s ease;
}

.toggle:hover {
  color: #475569;
}

.login-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.remember {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}

.remember input {
  accent-color: var(--accent);
}

.forgot {
  font-size: 12px;
  color: var(--accent);
  text-decoration: none;
  font-weight: 600;
}

.forgot:hover {
  text-decoration: underline;
}

.login-btn {
  height: 46px;
  margin-top: 6px;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.01em;
  border: none;
  border-radius: 12px;
  background: linear-gradient(145deg, #1e3a5f 0%, #2563eb 50%, #3b82f6 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 16px 32px rgba(30, 58, 95, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 36px rgba(30, 58, 95, 0.4);
  filter: saturate(1.1);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-text {
  margin-top: 4px;
  color: #b91c1c;
  font-size: 12px;
  background: #fff5f5;
  border: 1px solid #ffd5d5;
  padding: 8px 10px;
  border-radius: 10px;
}

.support {
  margin-top: 14px;
  font-size: 12px;
  color: #7f93b1;
}

.support span {
  color: #41597e;
  font-weight: 600;
}

@media (max-width: 900px) {
  .login-shell {
    max-width: 430px;
    grid-template-columns: 1fr;
  }

  .brand-panel {
    display: none;
  }

  .login-card {
    border-radius: 20px;
  }
}

@media (max-width: 520px) {
  .login-page {
    padding: 16px;
  }

  .login-card {
    padding: 22px 18px;
  }

  .login-card h1 {
    font-size: 22px;
  }
}
</style>
